"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosResponseInterceptor = void 0;
const domain_1 = require("../../../domain");
class AxiosResponseInterceptor {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
        this.resultStrategies = new Map([
            [domain_1.RootServices.DEFAULT, new domain_1.DefaultResultStrategy()],
            [domain_1.RootServices.APISERVER, new domain_1.ServerApiResultStrategy()],
            [domain_1.RootServices.KUNAPI, new domain_1.BuyerApiResultStrategy()],
            [domain_1.RootServices.BUYERAPI, new domain_1.BuyerApiResultStrategy()],
            [domain_1.RootServices.LIGHTHOUSEAPI, new domain_1.BuyerApiResultStrategy()],
            [domain_1.RootServices.GDTCAPI, new domain_1.BuyerApiResultStrategy()],
            [domain_1.RootServices.SELLERAPI, new domain_1.SellerApiResultStrategy()],
            [domain_1.RootServices.WECOM_MSG, new domain_1.WecomMsgResultStrategy()],
            [domain_1.RootServices.CCAPI, new domain_1.CCApiResultStrategy()],
            [domain_1.RootServices.OPENAPI, new domain_1.OpenApiResultStrategy()],
            [domain_1.RootServices.USERAPI, new domain_1.UserApiResultStrategy()],
            [domain_1.RootServices.PAYGW, new domain_1.PaygwResultStrategy()],
        ]);
        this.microStrategies = new Map([
            [domain_1.MicroScopes.APISERVER_PAGING, new domain_1.ServerApiPaginResultStrategy()],
        ]);
        this.microScopes = new Map([
            [domain_1.MicroScopes.APISERVER_SMS, domain_1.MicroScopes.APISERVER_SMS],
            [domain_1.MicroScopes.APISERVER_PAGING, domain_1.MicroScopes.APISERVER_PAGING],
        ]);
    }
    setupInterceptor() {
        this.addRequestInterceptor();
        this.addResponseInterceptor();
    }
    addRequestInterceptor() {
        this.axiosInstance.interceptors.request.use((config) => {
            var _a;
            const keysArray = Array.from(this.resultStrategies.keys());
            for (const key of keysArray) {
                if ((_a = config.baseURL) === null || _a === void 0 ? void 0 : _a.includes(key)) {
                    config.rootService = key;
                    break;
                }
            }
            if (config.microScope) {
                config.microScope = `${config.rootService}#${config.microScope || ''}`;
            }
            return config;
        });
    }
    addResponseInterceptor() {
        this.axiosInstance.interceptors.response.use((response) => {
            const { microScope } = response.config;
            if (microScope) {
                if (this.microScopes.get(microScope) === domain_1.MicroScopes.APISERVER_SMS) {
                    return domain_1.ResponseFactory.createResponse(response, this.resultStrategies.get(domain_1.RootServices.APISERVER));
                }
                if (this.microScopes.get(microScope) === domain_1.MicroScopes.APISERVER_PAGING) {
                    return domain_1.ResponseFactory.createResponse(response, this.microStrategies.get(domain_1.MicroScopes.APISERVER_PAGING));
                }
                return response;
            }
            return domain_1.ResponseFactory.createResponse(response, this.resultStrategies.get(response.config.rootService || domain_1.RootServices.DEFAULT));
        });
    }
}
exports.AxiosResponseInterceptor = AxiosResponseInterceptor;
//# sourceMappingURL=AxiosResponseInterceptor.js.map